// import React from 'react';
// import {
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	TextField,
// 	Button,
// 	FormControl,
// 	InputLabel,
// 	Select,
// 	MenuItem,
// 	Checkbox,
// 	ListItemText,
// 	Chip,
// 	Box,
// 	IconButton,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

// interface MenuType {
// 	_id: string;
// 	menuType: string;
// }

// interface EventType {
// 	_id: string;
// 	eventType: string;
// 	menuType: string[];
// }

// const MenuEventForm: React.FC<any> = ({
// 	open,
// 	onClose,
// 	onSubmit,
// 	isEditing,
// 	activeTab,
// 	menuTypes,
// 	currentItem,
// }) => {
// 	console.log(currentItem, 'menuTypes');

// 	const [newMenuType, setNewMenuType] = React.useState<string>('');
// 	const [newEventType, setNewEventType] = React.useState<string>('');
// 	const [selectedMenuTypes, setSelectedMenuTypes] = React.useState<string[]>([]);
// 	console.log(selectedMenuTypes, 'selectedMenuTypes');

// 	React.useEffect(() => {
// 		if (currentItem) {
// 			if ((currentItem as MenuType)?.menuType) {
// 				setNewMenuType((currentItem as MenuType).menuType);
// 			} else if ((currentItem as EventType)?.eventType) {
// 				const eventItem = currentItem as EventType;
// 				setNewEventType(eventItem.eventType);
// 				setSelectedMenuTypes(eventItem.menuType || []);

// 				setNewEventType(eventItem.eventType);
// 				setSelectedMenuTypes(eventItem.menuType);
// 			}
// 		} else {
// 			setNewMenuType('');
// 			setNewEventType('');
// 			setSelectedMenuTypes([]);
// 		}
// 	}, [currentItem]);

// 	const handleSubmit = () => {
// 		const data =
// 			activeTab === 0
// 				? { menuType: newMenuType }
// 				: { eventType: newEventType, menuType: selectedMenuTypes };
// 		onSubmit(data);
// 	};

// 	return (
// 		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
// 			<DialogTitle sx={{ color: 'black' }}>
// 				{isEditing ? 'Edit' : 'Add'} {activeTab === 0 ? 'Menu Type' : 'Event Type'}
// 				<IconButton
// 					aria-label="close"
// 					onClick={onClose}
// 					sx={{
// 						position: 'absolute',
// 						right: 8,
// 						top: 8,
// 						color: (theme) => theme.palette.grey[500],
// 					}}
// 				>
// 					<CloseIcon />
// 				</IconButton>
// 			</DialogTitle>
// 			<DialogContent sx={{ pt: 3 }}>
// 				{activeTab === 0 ? (
// 					<TextField
// 						margin="dense"
// 						label="Menu Type"
// 						type="text"
// 						fullWidth
// 						variant="outlined"
// 						value={newMenuType}
// 						onChange={(e) => setNewMenuType(e.target.value)}
// 						sx={{ mt: 2 }}
// 					/>
// 				) : (
// 					<>
// 						<TextField
// 							margin="dense"
// 							label="Event Type"
// 							fullWidth
// 							variant="outlined"
// 							value={newEventType || currentItem?.eventType}
// 							onChange={(e) => setNewEventType(e.target.value)}
// 							sx={{ mt: 2 }}
// 						/>
// 						<FormControl fullWidth sx={{ mt: 3 }}>
// 							<InputLabel>Menu Types</InputLabel>
// 							<Select
// 								multiple
// 								label="Menu Types"
// 								value={selectedMenuTypes}
// 								onChange={(e) => {
// 									const value = e.target.value;
// 									setSelectedMenuTypes(
// 										typeof value === 'string' ? value.split(',') : value
// 									);
// 								}}
// 								renderValue={(selected) => (
// 									<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
// 										{selected.map((menuName) => (
// 											<Chip
// 												key={menuName}
// 												label={menuName}
// 												size="small"
// 												color="primary"
// 												variant="outlined"
// 											/>
// 										))}
// 									</Box>
// 								)}
// 							>
// 								{menuTypes?.map((menuType: any) => (
// 									<MenuItem key={menuType._id} value={menuType.menuType}>
// 										<Checkbox
// 											checked={selectedMenuTypes.includes(menuType.menuType)}
// 										/>
// 										<ListItemText primary={menuType.menuType} />
// 									</MenuItem>
// 								))}
// 							</Select>
// 						</FormControl>
// 					</>
// 				)}
// 			</DialogContent>
// 			<DialogActions sx={{ p: 3 }}>
// 				<Button
// 					onClick={onClose}
// 					variant="outlined"
// 					color="error"
// 					sx={{
// 						mr: 2,
// 					}}
// 				>
// 					Cancel
// 				</Button>
// 				<Button
// 					onClick={handleSubmit}
// 					variant="contained"
// 					disabled={
// 						activeTab === 0
// 							? !newMenuType.trim()
// 							: !newEventType.trim() || selectedMenuTypes.length === 0
// 					}
// 					sx={{
// 						bgcolor: 'primary.main',
// 						'&:hover': { bgcolor: 'primary.dark' },
// 						'&:disabled': { bgcolor: 'action.disabled' },
// 					}}
// 				>
// 					{isEditing ? 'Update' : 'Add'}
// 				</Button>
// 			</DialogActions>
// 		</Dialog>
// 	);
// };

// export default MenuEventForm;
import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Checkbox,
	ListItemText,
	Chip,
	Box,
	IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface MenuType {
	_id: string;
	menuType: string;
}

interface EventType {
	_id: string;
	eventType: string;
	menuType: string[];
}

const MenuEventForm: React.FC<any> = ({
	open,
	onClose,
	onSubmit,
	isEditing,
	activeTab,
	menuTypes,
	currentItem,
}) => {
	console.log(currentItem, 'menuTypes');

	const [newMenuType, setNewMenuType] = React.useState<string>('');
	console.log(newMenuType, 'newMenuType');

	const [newEventType, setNewEventType] = React.useState<string>('');
	const [selectedMenuTypes, setSelectedMenuTypes] = React.useState<string[]>([]);

	React.useEffect(() => {
		if (currentItem) {
			setNewEventType(currentItem?.eventType || '');
			setSelectedMenuTypes(currentItem?.menuType || []);
		} else {
			setNewEventType('');
			setSelectedMenuTypes([]);
		}
		if (currentItem) {
			if ((currentItem as MenuType)?.menuType) {
				setNewMenuType((currentItem as MenuType).menuType);
			} else if ((currentItem as EventType)?.eventType) {
				const eventItem = currentItem as EventType;
				setNewEventType(eventItem.eventType);
				setSelectedMenuTypes(eventItem.menuType || []);
			}
		} else {
			setNewMenuType('');
			setNewEventType('');
			setSelectedMenuTypes([]);
		}
	}, [currentItem]);

	const handleSubmit = () => {
		const data =
			activeTab === 0
				? { menuType: newMenuType.trim() }
				: {
						eventType: newEventType.trim(),
						menuType: selectedMenuTypes.map((mt) => mt.trim()),
					};
		onSubmit(data);
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle sx={{ color: 'black' }}>
				{isEditing ? 'Edit' : 'Add'} {activeTab === 0 ? 'Menu Type' : 'Event Type'}
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ pt: 3 }}>
				{activeTab === 0 ? (
					<TextField
						margin="dense"
						label="Menu Type"
						type="text"
						fullWidth
						variant="outlined"
						value={newMenuType}
						onChange={(e) => setNewMenuType(e.target.value)}
						sx={{ mt: 2 }}
					/>
				) : (
					<>
						<TextField
							margin="dense"
							label="Event Type"
							fullWidth
							variant="outlined"
							value={newEventType}
							onChange={(e) => setNewEventType(e.target.value)}
							sx={{ mt: 2 }}
						/>
						<FormControl fullWidth sx={{ mt: 3 }}>
							<InputLabel>Menu Types</InputLabel>
							<Select
								multiple
								label="Menu Types"
								value={Array.isArray(selectedMenuTypes) ? selectedMenuTypes : []}
								onChange={(e) => {
									const value = e.target.value;
									setSelectedMenuTypes(
										typeof value === 'string' ? value.split(',') : value
									);
								}}
								renderValue={(selected) => (
									<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
										{(Array.isArray(selected) ? selected : []).map(
											(menuName) => (
												<Chip
													key={menuName}
													label={menuName}
													size="small"
													color="primary"
													variant="outlined"
												/>
											)
										)}
									</Box>
								)}
							>
								{menuTypes?.map((menuType: any) => (
									<MenuItem key={menuType._id} value={menuType.menuType}>
										<Checkbox
											checked={selectedMenuTypes.includes(menuType.menuType)}
										/>
										<ListItemText primary={menuType.menuType} />
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</>
				)}
			</DialogContent>
			<DialogActions sx={{ p: 3 }}>
				<Button
					onClick={onClose}
					variant="outlined"
					color="error"
					sx={{
						mr: 2,
					}}
				>
					Cancel
				</Button>
				<Button
					onClick={handleSubmit}
					variant="contained"
					disabled={
						activeTab === 0
							? !(typeof newMenuType === 'string' && newMenuType.trim())
							: !newEventType?.trim() || selectedMenuTypes?.length === 0
					}
					sx={{
						bgcolor: 'primary.main',
						'&:hover': { bgcolor: 'primary.dark' },
						'&:disabled': { bgcolor: 'action.disabled' },
					}}
				>
					{isEditing ? 'Update' : 'Add'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default MenuEventForm;
